import { StatsGrid } from '../../components/StatsGrid';
import { useAdminStats } from '../../hooks/useAdminStats';

export function DashboardSection() {
  const { stats, error, loading } = useAdminStats(true);

  return (
    <>
      <div className="section-header">
        <h1 className="console-title">Dashboard</h1>
        <p className="console-sub">Platform overview · real-time from API</p>
      </div>
      {error ? <p className="form-error section-error">{error}</p> : null}
      <StatsGrid stats={stats} loading={loading} />
    </>
  );
}
